import type { ConstValues } from '@openx/types/helpers.ts';
import type {
  FormSegment,
  LookalikeFormSegment,
} from '../../../../../../../../modules/audiences/AudienceForm/types.ts';

export type UsePaginationResult<T> = {
  loadingMore: boolean;
  allSegments: T[];
  totalCount: number;
  handleLoadMore: () => Promise<void>;
};

export type SegmentSelectionParams = {
  directSegments?: FormSegment[];
  rtgSegments?: FormSegment[];
  thirdPartySegments?: FormSegment[];
  siteCategorySegments?: FormSegment[];
  oxPurchaseSegments?: FormSegment[];
  lookalikeSegments?: LookalikeFormSegment[];
};

export type BaseBasicInfoParams = {
  id: string;
  reach?: number | null;
  displayReach: string;
  category: string;
  organizationName?: string | null;
  providerName?: string | null;
  isPredefinedSegment?: boolean;
};

export type PricedSegmentProps = BaseBasicInfoParams & {
  priced: true;
  pricePom: number;
  priceCpm: number;
  isLookalike: false;
};

export type UnpricedSegmentProps = BaseBasicInfoParams & {
  priced: false;
  isLookalike: false;
};

export type LookalikeSegmentProps = BaseBasicInfoParams & {
  isSelectedList: boolean;
  isLookalike: true;
  lookalikeReachRange: string | null;
  isSeed?: boolean;
  priced: false;
};

export type BasicInfoProps = PricedSegmentProps | UnpricedSegmentProps | LookalikeSegmentProps;

export const dataSourceOptions = {
  All: 'all',
  MyData: 'mydata',
  OpenXSelectData: 'openxselectdata',
  oxs3pData: 'oxs3pdata',
} as const;

export type DataSourceOptions = ConstValues<typeof dataSourceOptions>;

export const DATA_SOURCE_OPTIONS: DataSourceOptions[] = [
  dataSourceOptions.All,
  dataSourceOptions.MyData,
  dataSourceOptions.OpenXSelectData,
  dataSourceOptions.oxs3pData,
];
